import React from 'react';
import Reflux from 'reflux';
import Button from 'bootstrap/Button';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import role from 'shared/lib/role';
import UserSessionStore from 'flux/stores/UserSessionStore';

export default React.createClass({
  displayName: 'AddItemButton',

  mixins: [Reflux.connect(UserSessionStore, 'user')],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    let { teamId, eventId } = this.context.router.state.params;
    let hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );
    if (!hasEventAdmin) return <div />;

    return (
      <Button
        bsSize="small"
        onClick={this._handleAddItemClick}
        className="button-add-item"
      >
        <Icon name="plus-circle" />
        <span>Add Item</span>
      </Button>
    );
  },

  _handleAddItemClick() {
    CuesheetRowActions.addItemRow();
  },
});
